"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var ChatInteractionService_1;
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatInteractionServiceInstance = void 0;
const client_1 = require("@rws-framework/client");
const client_2 = require("@rws-framework/client");
const events_1 = require("@front/event/events");
let ChatInteractionService = ChatInteractionService_1 = class ChatInteractionService extends client_1.RWSService {
    constructor(apiService) {
        super();
        this.apiService = apiService;
        this.customHeaders = {};
    }
    /**
     * Initialize custom headers for API requests
     */
    initializeHeaders() {
        if (this.apiService.token && this.apiService.token !== '') {
            this.customHeaders = {
                'Authorization': 'Bearer ' + this.apiService.token,
            };
        }
        else if (this.apiService.apiKey && this.apiService.apiKey !== '') {
            this.customHeaders = {
                'x-api-key': this.apiService.apiKey,
            };
        }
        if (ChatInteractionService_1.VERBOSE) {
            console.log('[ChatInteractionService] Initialized custom headers:', this.customHeaders);
        }
    }
    /**
     * Handle web search checkbox change event
     */
    handleWebSearchChange(checked, emitCallback) {
        if (ChatInteractionService_1.VERBOSE) {
            console.log('[ChatInteractionService] Handling web search change:', checked);
        }
        if (emitCallback) {
            if (ChatInteractionService_1.VERBOSE) {
                console.log('[ChatInteractionService] Emitting web search event:', events_1.appEvents.frontChatWebSearch);
            }
            emitCallback(events_1.appEvents.frontChatWebSearch, checked);
        }
    }
    /**
     * Handle deep search checkbox change event
     */
    handleDeepSearchChange(checked, emitCallback) {
        if (ChatInteractionService_1.VERBOSE) {
            console.log('[ChatInteractionService] Handling deep search change:', checked);
        }
        if (emitCallback) {
            if (ChatInteractionService_1.VERBOSE) {
                console.log('[ChatInteractionService] Emitting deep search event:', events_1.appEvents.frontChatDeepSearch);
            }
            emitCallback(events_1.appEvents.frontChatDeepSearch, checked);
        }
    }
    /**
     * Reset chat component
     */
    resetChat(chatElement, getOverrides) {
        if (ChatInteractionService_1.VERBOSE) {
            console.log('[ChatInteractionService] Resetting chat component');
            console.log('[ChatInteractionService] Current overrides:', getOverrides());
        }
        if (chatElement) {
            chatElement.dataset.overrides = getOverrides();
            chatElement.requestUpdate();
            if (ChatInteractionService_1.VERBOSE) {
                console.log('[ChatInteractionService] Chat component reset and update requested');
            }
        }
        else if (ChatInteractionService_1.VERBOSE) {
            console.log('[ChatInteractionService] No chat element provided for reset');
        }
    }
    /**
     * Clear chat component
     */
    clearChat(chatElement, getOverrides, currentAvatar) {
        if (chatElement) {
            chatElement.dataset.overrides = getOverrides();
            console.log('[ChatInteractionService] Clearing chat with overrides:', getOverrides(), 'and current avatar:', currentAvatar, { chatElement });
            chatElement.clearChat();
            chatElement.requestUpdate();
        }
    }
    /**
     * Append text to chat input
     */
    appendInputTextToChat(chatElement, text, send = false, hidden = false) {
        if (chatElement) {
            chatElement.setInputValue(text, true, send, hidden);
        }
    }
    /**
     * Update custom headers
     */
    updateHeaders(headers) {
        this.customHeaders = { ...this.customHeaders, ...headers };
    }
    /**
     * Get current headers
     */
    getHeaders() {
        return this.customHeaders;
    }
    /**
     * Refresh API token in headers
     */
    refreshToken() {
        this.customHeaders['Authorization'] = 'Bearer ' + this.apiService.token;
    }
};
exports.ChatInteractionServiceInstance = ChatInteractionService;
ChatInteractionService.VERBOSE = false;
exports.ChatInteractionServiceInstance = ChatInteractionService = ChatInteractionService_1 = __decorate([
    __param(0, client_2.ApiService),
    __metadata("design:paramtypes", [typeof (_a = typeof client_2.ApiServiceInstance !== "undefined" && client_2.ApiServiceInstance) === "function" ? _a : Object])
], ChatInteractionService);
exports.default = ChatInteractionService.getSingleton();
